export function renderContactPage() {
  return `
    <main>
      <section class="contact-section" aria-labelledby="contact-title">
        <div class="contact-intro">
          <a class="back-link" href="/" data-route>Back</a>
          <p class="eyebrow">Enquiries</p>
          <h1 id="contact-title">Contact Us</h1>
          <p>
            Send us a note about access, partnerships, press, community questions, or anything else
            that belongs with the womyn.network team.
          </p>
        </div>

        <form
          class="interest-form contact-form"
          action="https://api.web3forms.com/submit"
          method="POST"
        >
          <input type="hidden" name="access_key" value="b72ab339-ae8e-400b-ac8c-3184f18a8c2f">
          <input type="hidden" name="subject" value="New womyn.network enquiry">
          <input type="checkbox" name="botcheck" class="botcheck" tabindex="-1" autocomplete="off">

          <div class="form-row">
            <label>
              Full name
              <input type="text" name="name" autocomplete="name" placeholder="Jane Doe" required>
            </label>

            <label>
              Email
              <input type="email" name="email" autocomplete="email" placeholder="jane@company.com" required>
            </label>
          </div>

          <label>
            What can we help with?
            <textarea
              name="message"
              rows="6"
              placeholder="Tell us about your enquiry..."
              required
            ></textarea>
          </label>

          <button class="form-submit" type="submit">Send Enquiry</button>
        </form>

        <section class="collaborator-panel" id="collaborate" aria-labelledby="collaborate-title">
          <div class="collaborator-copy">
            <p class="eyebrow">Collaborate</p>
            <h2 id="collaborate-title">Work With Us</h2>
            <p>
              For collaborators, interested investors, future team members, and specialists who
              want to help shape womyn.network.
            </p>
          </div>

          <form
            class="interest-form contact-form"
            action="https://api.web3forms.com/submit"
            method="POST"
          >
            <input type="hidden" name="access_key" value="d403e839-0a28-432f-ab6f-2f80deb1d60e">
            <input type="hidden" name="subject" value="New womyn.network collaboration enquiry">
            <input type="checkbox" name="botcheck" class="botcheck" tabindex="-1" autocomplete="off">

            <div class="form-row">
              <label>
                I am a
                <select name="collaborator_type" required>
                  <option value="">Choose one</option>
                  <option value="Collaborator">Collaborator</option>
                  <option value="Interested investor">Interested investor</option>
                  <option value="Potential team member">Potential team member</option>
                  <option value="Brand or organisation">Brand or organisation</option>
                  <option value="Specialist or advisor">Specialist or advisor</option>
                  <option value="Other">Other</option>
                </select>
              </label>

              <label>
                Specialty <span class="field-note">(if applicable)</span>
                <input type="text" name="specialty" placeholder="Product, funding, community, legal...">
              </label>
            </div>

            <label>
              Company email
              <input type="email" name="company_email" autocomplete="email" placeholder="you@company.com" required>
            </label>

            <label>
              Message
              <textarea
                name="message"
                rows="6"
                placeholder="Tell us how you would like to collaborate..."
                required
              ></textarea>
            </label>

            <button class="form-submit" type="submit">Send Collaboration Note</button>
          </form>
        </section>
      </section>
    </main>
  `;
}
